import type { ReactNode } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface ResponsiveSplitProps {
  mobile: ReactNode;
  desktop: ReactNode;
}

export function ResponsiveSplit({ mobile, desktop }: ResponsiveSplitProps) {
  return useIsMobile() ? <>{mobile}</> : <>{desktop}</>;
}
